// src/store/thunks/create-six/createSixThunk.ts
import type { SixCreated } from "@/services/abstract/CreateSixService";
import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";
import { isAPIError } from "@/store/utils";
import type { CreateSixPayload } from "@/types/create-six.types";
import { withErrorHandling, withLoader } from "@/store/thunks/thunkWrappers";
import { HTTP_STATUS_CONFLICT } from "@/config/apiConfig";
import { fetchSixCatalogThunk } from "@/store/thunks/sixCatalog/fetchSixCatalog";
import { publishOrgGlobalMessageThunk } from "@/store/thunks/poc/messaging/publishOrgGlobalMessageThunk";
import { createSixCreatedMessage } from "@/types/poc/messageFactory";
export const createSixThunk = createAppAsyncThunk<
  SixCreated,
  CreateSixPayload,
  { rejectValue: { fieldErrors: Record<string, string> } }
>(
  "createSix/createSixThunk",
  withLoader(
    withErrorHandling(
      async(payload, thunkAPI) => {
        const { extra, rejectWithValue, dispatch } = thunkAPI;

        try {
          const result = await extra.createSixService.createSix(payload);
          await dispatch(fetchSixCatalogThunk());
          void dispatch(publishOrgGlobalMessageThunk({
            message: createSixCreatedMessage(),
          }));
          return result;
        } catch (error) {
          if (isAPIError(error) && error.status === HTTP_STATUS_CONFLICT) {
            return rejectWithValue({ fieldErrors: { name: "Duplicate name" } });
          }
          throw error;
        }
      }
    )
  )
);
